import { useEffect, type RefObject } from 'react';

const handleMousedown = (event: MouseEvent) => {
  event.preventDefault();
};

/**
 * Keeps focus on the cascader input when the user interacts with the dropdown surface
 * (list, scrollbar, etc.) by canceling the default mousedown focus transfer.
 */
export const usePreventDropdownMousedownFocus = (
  containerRef: RefObject<HTMLElement | null>,
): void => {
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    el.addEventListener('mousedown', handleMousedown);
    return () => el.removeEventListener('mousedown', handleMousedown);
  }, [containerRef]);
};
